import React, { useEffect, useRef, useState } from "react";
import { TextField, InputAdornment } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import { useTranslation } from "@/langs/useTranslation";
import "./auto-complete.scss";

function AutoComplete({ AMap, onSelect }) {
  const { t } = useTranslation();
  const inputRef = useRef(null);
  const [showSugguest, setShowSugguest] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  function select(e) {
    onSelect(e);
    setSuggestions([]); // Clear suggestions on select
  }

  const searchCallback = (status, result) => {
    if (status === "complete" && result.info === "OK") {
      setSuggestions(result.tips);
    }
  };

  var autoComplete = null;

  useEffect(() => {
    if (AMap === null) return;
    const autoOptions = {
      // input: inputRef.current,
    };
    //实例化AutoComplete
    autoComplete = new AMap.AutoComplete(autoOptions);
    autoComplete.on("select", select);

    if (inputRef.current) {
      inputRef.current.addEventListener("input", () => {
        if (inputRef.current.value.trim()) {
          autoComplete.search(inputRef.current.value, searchCallback);
        } else {
          setSuggestions([]);
        }
      });
    }

    return () => {
      autoComplete.off("select", select);
    };
  }, [AMap]);

  return (
    <div className="autocomplete-container">
      <TextField
        variant="outlined"
        size="small"
        fullWidth
        placeholder={t({ defaultMessage: "搜索地址" })}
        inputRef={inputRef}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search color="disabled" />
            </InputAdornment>
          )
        }}
        onFocus={() => setShowSugguest(true)}
        onBlur={() => setShowSugguest(false)}
      />
      {showSugguest && suggestions.length > 0 && (
        <ul className="suggestions-list">
          {suggestions.map((suggestion, index) => (
            <li
              key={index}
              className="suggestion-item"
              onMouseDown={() => {
                select({ poi: suggestion });
                inputRef.current.value = suggestion.name;
              }}
              onTouchStart={() => {
                select({ poi: suggestion });
                inputRef.current.value = suggestion.name;
              }}
            >
              <span className="suggestion-name">{suggestion.name}</span>{" "}
              <span className="suggestion-district">{suggestion.district}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default AutoComplete;
